import * as Yup from "yup";
import checkout from "./Form";

const {
  formField: {
    // datas
    fullName,
    socialName,
    CPF,
    birthDate,
    documentNumber,
    issuingAgency,
    FUData,
    issueDate,
    nationality,
    birthCity,
    birthFU,
    motherName,
    fatherName,
    // contacts
    email,
    phone,
    contact,
    // address
    CEP,
    street,
    number,
    FUAddress,
    district,
    city,
    mailingAddress,
    // complements
    // descriptions
    // documents
  },
} = checkout;

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  // messages
  Yup.object().shape({}),
  // documents
  Yup.object().shape({}),
  // datas
  Yup.object().shape({
    [fullName.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Nome Completo só aceita letras"
      ),
      // .required(fullName.errorMsg),
    [socialName.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Nome Social só aceita letras"
      ),
      // .required(socialName.errorMsg),
    [CPF.name]: Yup.string()
      .test("cpf", "CPF inválido", function (item) {
        var strCPF = item ? item.replaceAll(".", "").replaceAll("-", "") : "";
        var Soma;
        var Resto;
        Soma = 0;
        if (strCPF === "00000000000") return false;

        for (let i = 1; i <= 9; i++)
          Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;

        if (Resto === 10 || Resto === 11) Resto = 0;
        if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

        Soma = 0;
        for (let i = 1; i <= 10; i++)
          Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;

        if (Resto === 10 || Resto === 11) Resto = 0;
        if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
        return true;
      })
      // .required(CPF.errorMsg)
      .min(14, CPF.invalidMsg),
    [birthDate.name]: Yup.string()
      // .required(birthDate.errorMsg)
      .min(10, birthDate.invalidMsg),
    // [value]: Yup.string().required(sex.errorMsg),
    // [documentType.name]: Yup.string().required(documentType.errorMsg),
    [documentNumber.name]: Yup.string()
      .matches(/^\d+$/, "O campo Número do Documento só aceita números"),
      // .required(documentNumber.errorMsg),
    [issuingAgency.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Orgão Emissor só aceita letras"
      ),
      // .required(issuingAgency.errorMsg),
    [FUData.name]: Yup.string()
      .max(2, "O campo UF necessita conter apenas dois carácteres")
      .matches(/^[a-zA-Z]+$/, "O campo UF só aceita letras"),
      // .required(FUData.errorMsg),
    [issueDate.name]: Yup.string(),
    // .required(issueDate.errorMsg),
    [nationality.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Nacionalidade só aceita letras"
      ),
      // .required(nationality.errorMsg),
    [birthCity.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Cidade de Nascimento só aceita letras"
      ),
      // .required(birthCity.errorMsg),
    [birthFU.name]: Yup.string()
      .max(
        2,
        "O campo UF de nascimento necessita conter apenas dois carácteres"
      )
      .matches(/^[a-zA-Z]+$/, "O campo UF de nascimento só aceita letras"),
      // .required(birthFU.errorMsg),
    [motherName.name]: Yup.string()
      .matches(
        /^[a-zA-Z\u00C0-\u00FF\s]*$/,
        "O campo Nome da Mãe só aceita letras"
      ),
      // .required(motherName.errorMsg),
    [fatherName.name]: Yup.string().matches(
      /^[a-zA-Z\u00C0-\u00FF\s]*$/,
      "O campo Nome do Pai só aceita letras"
    ),
  }),
  // contacts
  Yup.object().shape({
    [email.name]: Yup.string()
    // .required(email.errorMsg)
    .email(email.invalidMsg),
    [phone.name]: Yup.string()
      // .required(phone.errorMsg)
      .min(14, phone.invalidMsg),
    // [formOfContact.name]: Yup.string().required(formOfContact.errorMsg),
    [contact.name]: Yup.string(),
      // .required(contact.errorMsg),
  }),
  // address
  Yup.object().shape({
    [CEP.name]: Yup.string()
    // .required(CEP.errorMsg)
    .min(9, CEP.invalidMsg),
    [street.name]: Yup.string(),
    // .required(street.errorMsg),
    [number.name]: Yup.string()
      .matches(/^\d+$/, "O campo Número só aceita números"),
      // .required(number.errorMsg),
    // [complements.name]: Yup.string().required(complements.errorMsg),
    [FUAddress.name]: Yup.string()
      .max(2, "O campo UF necessita conter apenas dois carácteres")
      .matches(/^[a-zA-Z]+$/, "O campo UF só aceita letras"),
      // .required(FUAddress.errorMsg),
    [district.name]: Yup.string(),
    // .required(district.errorMsg),
    [city.name]: Yup.string()
      .matches(/^[a-zA-Z\u00C0-\u00FF\s]*$/, "O campo Cidade só aceita letras"),
      // .required(city.errorMsg),
    [mailingAddress.name]: Yup.string()
    // .required(mailingAddress.errorMsg),
  }),
  // complements
  Yup.object().shape({
    // [income.name]: Yup.string().required(income.errorMsg),
  }),
  // descriptions
  Yup.object().shape({}),
];
